/**
 * Modal overlay which can load content dynamically by supplying it with an
 * options object
 * {
 *  url: source to retrieve
 *  element: element to retrieve from the source
 * }
 */
import { TweenLite } from "gsap";

// const flickity = require('flickity')
// require('fingerprintjs2');

// import flickity from 'flickity'
//  const ContentLoader = require('../modules/module-content-loader')

// const fl
// const flickity = require('../vendor/flickity');

module.exports = function (app) {
  app.registerComponent("slider", ".js-slider", function (sb, el) {
    const container = el.querySelector(".slider__items");
    const caption = el.querySelector(".js-slider-caption");

    const buttonBack = el.querySelector(".js-slider-back");
    const buttonNext = el.querySelector(".js-slider-next");

    var flkty;

    const items = Array.from(container.children).map((el, index) => {
      console.log(index)
      let figcaption = el.querySelector("figcaption");
      let itemButton = el.querySelector(".js-video-overlay");
      var playerInstance;
      let type = el.classList.contains("slider__item--video")
        ? "video"
        : "image";

      // load the iframe
      if (type === "video") {
        //
        const iframe = el.querySelector("iframe");
        if (iframe) {
          // console.log(YT);
          playerInstance = new YT.Player(iframe, {});

          playerInstance.addEventListener("onStateChange", (event) => {
            onYoutubeStateChanged(index, event) 
          });


          playerInstance.addEventListener("onReady", (event) => {
            onYoutubePlayerReady(index, event) 
          });
        }
   
      }
      return {
        el: el,
        caption: figcaption ? figcaption.textContent : "",
        type: type,
        videoButton: itemButton,
        playerInstance: playerInstance,
        playerReady: false
      };
    });

    const onYoutubePlayerReady = (slideIndex, event) => { 
      const item = items[slideIndex];
      console.log('player ready')
      item.playerReady = true;

    };
    const onYoutubeStateChanged = (slideIndex, event) => {
      const item = items[slideIndex];
      if (!item.playerInstance) return;
      console.log(item.el)

      console.log(event.data)
      // if (event.data == 0) {
      //   item.el.classList.remove("overlay-hidden");

      // } else if (event.data > 0) {
      //   item.el.classList.add("overlay-hidden");
      // }
    
    }

    const onClickNext = () => {
      if (flkty.selectedIndex === items.length - 1) {
        flkty.select(0);
      } else {
        flkty.next();
      }
    };

    const onSlideSelect = (evIndex) => {
      let index = flkty.selectedIndex;
      let item = items[index];

      if (evIndex === undefined) {
        caption.innerHTML = item.caption;
      } else {
        TweenLite.to(caption, 0.3, {
          opacity: 0,
          onComplete: () => {
            caption.innerHTML = item.caption;
            TweenLite.to(caption, 0.3, {
              opacity: 1,
            });
          },
        });
      }

      // check if the buttons need to be shown
      if (index === flkty.cells.length - 1) {
        buttonNext.classList.add("is-hidden");
        buttonBack.classList.remove("is-hidden");
      } else {
        buttonNext.classList.remove("is-hidden");
        buttonBack.classList.add("is-hidden");
      }
      
      // stop the playing of all player instances
      items.forEach((item, i) => {
        if (item.type === "video" && item.playerReady ) {
          item.playerInstance.stopVideo();
          item.el.classList.remove("overlay-hidden");

        }
      });
    };

    const onClickBack = () => {
      if (flkty) {
        flkty.select(0);
      }
    };

    const startVideo = (index) => {
      const item = items[index];

      const iframe = item.el.querySelector("iframe");

      console.log(item);
      item.playerInstance.playVideo();

      // // console.log(YT);
      // const player =  new YT.Player(iframe, {
      //   onReady: function(event) {
      //     console.log("a");
      //     // event.target.playVideo();
      //   },
      //   onStateChange: function(event) {
      //     console.log("b");
      //     // console.log(event)
      //   }
      // });

      // setTimeout(() => {
      //   console.log(player)
      //   player.playVideo();
      // }, 100);
    };
    const onVideoButtonClick = (e) => {
      e.preventDefault();

      let index = 0;
      if (flkty) {
        index = flkty.selectedIndex;
      }
      const item = items[index];
      item.el.classList.add("overlay-hidden");

      startVideo(index);
      // startVideo(flkty.selectedIndex)
    };
    // all children of element

    /* INIT ------------------------------------------- */
    return {
      init: function () {
        if (items.length > 1) {
          flkty = new Flickity(container, {
            // options
            // cellAlign: 'center',
            prevNextButtons: false,
            pageDots: false,
            contain: true,
          });

          flkty.on("select", onSlideSelect);

          onSlideSelect();

          if (buttonNext) {
            buttonNext.addEventListener("click", onClickNext);
          }
          if (buttonBack) {
            buttonBack.addEventListener("click", onClickBack);
          }
        }

        items.forEach((item) => {
          if (item.type === "video") {
            if (item.videoButton) {
              item.videoButton.addEventListener("click", onVideoButtonClick);
            }
          }
        });
        // console.log(Flickity)
      },
      destroy: function () {
        if (flkty) flkty.destroy();

        if (buttonNext) {
          buttonNext.removeEventListener("click", onClickNext);
        }

        items.forEach((item) => {
          if (item.type === "video") {
            if (item.videoButton) {
              item.videoButton.removeEventListener("click", onVideoButtonClick);
            }
          }
        });
      },
    };
  });
};



// WEBPACK FOOTER //
// ./assets/js/components/slider.js